import { Box, Text, Tooltip } from "@chakra-ui/react";
import { Fragment } from "react";

const DEFAULT_MAX = 20;

const getLocationString = (loc) => {
  if (typeof loc === "string") return loc;
  return loc?.name || loc?.description || loc?.address || "";
};

const truncate = (text) => {
  if (!text) return "";
  const firstCommaIndex = text.indexOf(",");
  const firstWhitespaceIndex = text.indexOf(" ");

  if (firstCommaIndex !== -1) {
    return text.slice(0, firstCommaIndex);
  }

  return firstWhitespaceIndex !== -1 ? text.slice(0, firstWhitespaceIndex) : text;
};


const RouteFlow = ({ from, to, stops = [], tripType, showWhenNoStops = true }) => {
  const startRaw = getLocationString(from);
  const endRaw = getLocationString(to);
  const hasStart = !!startRaw;
  const hasEnd = !!endRaw;
  const normalizedTripType = String(tripType || "").trim().toUpperCase();
  const isLocalRentalType = ["LR", "HR", "LOCAL", "LOCALRENTAL", "LOCAL_RENTAL"].includes(
    normalizedTripType,
  );

  if (isLocalRentalType) return null;

  const stopNames = (stops || [])
    .map((stop) => getLocationString(stop))
    .filter((stop) => stop && stop.trim());

  if (!showWhenNoStops && stopNames.length === 0) return null;

  const start = startRaw || "Start";
  const end = endRaw || "Destination";

  const segments = [start, ...stopNames, end];
  const isRoundTrip = ["RT", "OUTSTATIONROUNDTRIP"].includes(normalizedTripType);

  if (isRoundTrip && hasStart && hasEnd) {
    segments.push(start);
  }

  const visibleSegments = segments.filter(
    (segment) => String(segment).trim().toLowerCase() !== "local",
  );

  if (visibleSegments.length < 2) return null;

  return (
    <Box
      bg="blue.50"
      borderRadius="md"
      p={3}
      borderLeft="3px solid"
      borderColor="blue.500"
    >
      <Text fontSize="xs" fontWeight="600" color="blue.700" mb={1}>
        Trip Route:
      </Text>
      <Text fontSize="sm" color="blue.800" fontWeight="500">
        {visibleSegments.map((segment, index) => (
          <Fragment key={`${segment}-${index}`}>
            {index > 0 && (
              <Text as="span" color="blue.600">
                {" → "}
              </Text>
            )}
            <Tooltip label={segment} hasArrow placement="top">
              <Text as="span" cursor="help">
                {truncate(segment)}
              </Text>
            </Tooltip>
          </Fragment>
        ))}
      </Text>
    </Box>
  );
};

export default RouteFlow;